"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize0 = void 0;
/** Memoize a function with no arguments. */
function memoize0(fn) {
    var wrapCache = undefined;
    var memoizedFn = function () {
        if (wrapCache === undefined) {
            wrapCache = [fn()];
        }
        return wrapCache[0];
    };
    return memoizedFn;
}
exports.memoize0 = memoize0;
//# sourceMappingURL=memoize0.js.map